export default {
  required: (v) => !!v || "Campo Obrigatório",
  email: (v) => /.+@.+\..+/.test(v) || "Informe um e-mail válido",
  phone: (v) => (!!v && v.length === 15) || "Informe um número válido",
  password: (v) =>
    (!!v && v.length >= 8) || "Use 8 caracteres ou mais para sua senha",
  document: (v) =>
    v.length === 14 || v.length === 18 || "Informe uma numeração válida",
};
